import { fieldTypeMessages } from '../../../../constants/fieldType';
import { Button } from 'foundations-components/transitional/components/Button';
import { Flex } from 'foundations-components/components/Flex';
import FormattedMessage from 'I18n/components/FormattedMessage';
import I18n from 'I18n';
import { Select } from 'foundations-components/transitional/components/Select';
import once from 'transmute/once';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getOptions = once(() => {
  return Object.entries(fieldTypeMessages).map(([value, messageKey]) => ({
    value,
    text: I18n.text(messageKey)
  }));
});
const ButtonContent = ({
  count
}) => {
  if (count === 0) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "customerDataFiltersUI.dataExplorer.typeFilterBar.fieldTypes.label"
    });
  }
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: "customerDataFiltersUI.dataExplorer.typeFilterBar.fieldTypes.withCount",
    options: {
      count
    }
  });
};
// eslint-disable-next-line react/no-multi-comp
const FieldTypeFilterBar = ({
  onChange,
  values
}) => {
  const options = getOptions();
  const onClear = () => {
    onChange([]);
  };
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "customerDataFiltersUI.dataExplorer.typeFilterBar.filterBy"
    }), /*#__PURE__*/_jsx(Select, {
      ButtonContent: ButtonContent,
      buttonContentProps: {
        count: values.length
      },
      anchorType: "button",
      buttonUse: "transparent",
      onChange: evt => onChange(evt.target.value),
      options: options,
      menuWidth: "auto",
      multi: true,
      value: values
    }), values.length > 0 && /*#__PURE__*/_jsx(Button, {
      use: "transparent",
      onClick: onClear,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "customerDataFiltersUI.dataExplorer.typeFilterBar.clear"
      })
    })]
  });
};
export default FieldTypeFilterBar;